import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { useNavigate } from "react-router-dom";
import { categorySchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useCategoryForm } from "./useCategoryForm";
import { PermissionControlledInput } from "permissions/components/input";
import { FormLabel } from "components/form";
import SelectStatus from "components/select/status";

const CategoryForm = ({ categoryId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useCategoryForm({
    categoryId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={categoryId || "+"}
      schema={categorySchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Name Field */}
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem>
                <PermissionControlledInput
                  rule={isNewItem ? "create:*" : "update:*"}
                  collection="survey_categories"
                  type="form"
                >
                  <FormLabel required>Name</FormLabel>
                  <Input {...field} />
                </PermissionControlledInput>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Status</FormLabel>
                <SelectStatus
                  collection="survey_categories"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="survey_categories"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default CategoryForm;
